<template>
  <b-card class="cardboardTop" title="Please tell us about the bags or wallets involved.">
    <b-alert variant="primary" show>
      <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon>&nbsp;&nbsp;This item will not be added until you click the
      <b>'Add property'</b> button below
    </b-alert>

       <transition name="fade" mode="out-in">
          <div id="errorCardTop" class="errorCard" v-if="error == true">
            <b-card class="errorCard">
              <h1>Validation Errors</h1>

              <ul>
                <li
                  v-for="(item, index) in errormessage"
                  v-bind:key="errormessage[index]"
                >{{ item }}</li>
              </ul>

              <span>
                <i>Please correct all the above validation errors before you can add this property</i>
              </span>
            </b-card>
          </div>
        </transition>



    <b-form-group>
      <b-row>
        <b-col cols="2" v-on:click="Property.type == 'Wallet'">
          <div
            v-on:click="Property.type == 'Wallet'"
            v-bind:class="{ npfactive: Property.type == 'Wallet', npfnonActive :Property.type != 'Wallet' }"
          >
            <input
              v-on:click="Property.type == 'Wallet'"
              type="radio"
              id="WalletType"
              value="Wallet"
              v-model="Property.type"
            >
            <label for="WalletType">Wallet</label>
          </div>
        </b-col>
        <b-col cols="2" v-on:click="Property.type == 'Purse'">
          <div
            v-on:click="Property.type == 'Purse'"
            v-bind:class="{ npfactive: Property.type == 'Purse', npfnonActive :Property.type != 'Purse' }"
          >
            <input
              v-on:click="Property.type == 'Purse'"
              type="radio"
              id="PurseType"
              value="Purse"
              v-model="Property.type"
            >
            <label for="PurseType">Purse</label>
          </div>
        </b-col>

        <b-col cols="2" v-on:click="Property.type == 'Handbag'">
          <div
            v-on:click="Property.type == 'Handbag'"
            v-bind:class="{ npfactive: Property.type == 'Handbag', npfnonActive :Property.type != 'Handbag' }"
          >
            <input type="radio" id="HandbagType" value="Handbag" v-model="Property.type">
            <label v-on:click="Property.type == 'Handbag'" for="HandbagType">Handbag</label>
          </div>
        </b-col>
           <b-col cols="2" v-on:click="Property.type == 'Backpack'">
          <div
            v-on:click="Property.type == 'Backpack'"
            v-bind:class="{ npfactive: Property.type == 'Backpack', npfnonActive :Property.type != 'Backpack' }"
          >
            <input type="radio" id="BackpackType" value="Backpack" v-model="Property.type">
            <label v-on:click="Property.type == 'Backpack'" for="BackpackType">Backpack</label>
          </div>
        </b-col>
          
           <b-col cols="2" v-on:click="Property.type == 'Luggage'">
          <div
            v-on:click="Property.type == 'Luggage'"
            v-bind:class="{ npfactive: Property.type == 'Luggage', npfnonActive :Property.type != 'Luggage' }"
          >
            <input type="radio" id="LuggageType" value="Luggage" v-model="Property.type">
            <label v-on:click="Property.type == 'Luggage'" for="LuggageType">Luggage</label>
          </div>
        </b-col>
        <b-col cols="2" v-on:click="Property.type == 'Other'">
          <div
            v-on:click="Property.type == 'Other'"
            v-bind:class="{ npfactive: Property.type == 'Other', npfnonActive :Property.type != 'Other' }"
          >
            <input
              v-on:click="Property.type == 'Other'"
              type="radio"
              id="TypeOther"
              value="Other"
              v-model="Property.type"
            >
            <label for="TypeOther">Other</label>
          </div>
        </b-col>
      </b-row>
    </b-form-group>

    <b-form-group>
      <b-row>
        <b-col cols="12">
          <span class="npfQuestion">Describe the item</span>
          <br>
          <span class="npfsubquestion">For example, colour, material and size</span>
          <b-form-textarea v-model="Property.describeitem" rows="5"
            max-rows="12" placeholder="What colour is it? Size etc"></b-form-textarea>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col cols="12">
          <span class="npfQuestion">Describe any contents</span>
      
          <b-form-textarea
            v-model="Property.describecontents"
            rows="5"
            max-rows="12"
            placeholder="Describe any contents"
          ></b-form-textarea>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col cols="12">
          <b-button v-on:click="$emit('cancelproperty')" variant="danger">
            Cancel
            <font-awesome-icon :icon="['fas', 'times-circle']"></font-awesome-icon>
          </b-button>
          <b-button v-on:click="addchildproperty()" variant="success">
            Add Property
            <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>&nbsp;
            <font-awesome-icon :icon="['fas', 'shopping-bag']"></font-awesome-icon>
          </b-button>
        </b-col>
      </b-row>
    </b-form-group>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      Property: {
        type: "",
        describeitem: "",
        describecontents: "",
      },
      error: false,
      errormessage: []
    };
  },
  methods: {
    addchildproperty: function() {
      this.error = false;
      this.errormessage = [];

      if (this.Property.type == "") {
        this.error = true;
        this.errormessage.push("Please select a property type");
      }
        if (this.Property.describeitem == "" && this.Property.describecontents == "" ) {
        this.error = true;
        this.errormessage.push("Please supply more information, either a describe the item or supply the contents");
      }
      if (!this.error) {
        this.$emit("addproperty", this.Property);
      }
      else  
      {
          this.errorMessage();
      }
    },
     errorMessage() {
      var errormessage = this.errormessage;
      var htmlerror = "<div style='text-align: left;'><ul>";
      errormessage.forEach(function(item) {
        htmlerror += "<li>" + item + "</li>";
      });
      htmlerror += "</ul></div>";

      this.$swal("Validation Error(s)", htmlerror, "error");
    },
  }
};
</script>

<style>
</style>
